// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-v0.8.0." + {"133":"c5f8790175b1ec4655d5","204":"e9ec63faf52c35c1076c","241":"848775e55ffd1919ae9e","364":"e1b77fccbca379d2dab3","644":"00501b69e15cdf66770f"}[chunkId] + ".js";
};